import { push } from 'react-router-redux';
import * as authReducer from '../../redux/modules/auth';
import * as authActions from "../../redux/modules/auth";

const mapStateToProps = state => ({
  user: state.auth.user,
});

const mapDispatchToProps = {
  ...authReducer,
  push
};

export default [mapStateToProps, mapDispatchToProps];



// WEBPACK FOOTER //
// ./src/containers/auth/index.js